__turbopack_context__.v({
  "bounce": "qmkSxW_bounce",
  "pin": "qmkSxW_pin",
  "pulsate": "qmkSxW_pulsate",
  "pulse": "qmkSxW_pulse",
});
